module.exports = __webpack_public_path__ + "static/Jasu-Koponen-fa45310b7652e10827050574de0c5c9f.jpeg";